/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTile_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"Shipping_viewer">;
    readonly " $refType": "ItemTile_viewer";
};
export type ItemTile_viewer$data = ItemTile_viewer;
export type ItemTile_viewer$key = {
    readonly " $data"?: ItemTile_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTile_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemTile_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userZipCode",
      "type": "String",
      "defaultValue": "0"
    },
    {
      "kind": "LocalArgument",
      "name": "userCountryCode",
      "type": "String",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Shipping_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ]
    }
  ]
};
(node as any).hash = '75cfd7acd02e60bd98bc1bf210582dde';
export default node;
